import CheckinCheckoutCell from './checkin_checkout_cell';
import GapDaysCell from './gap_days_cell';
import LastCommentCell from './last_comment_cell';
import PropertyCell from './property_cell';
import ReadyStatusCell from './ready_status_cell';
import RecentTasksCell from './recent_tasks_cell';
import ReservationCell from './reservation_cell';
import TasksCell from './tasks_cell';

import './default_cell.scss';

export default {
  CheckinCheckoutCell,
  GapDaysCell,
  LastCommentCell,
  PropertyCell,
  ReadyStatusCell,
  RecentTasksCell,
  ReservationCell,
  TasksCell,
};
